import "./super-agent-user.css";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { CustomBreadcrumb } from "../../../shared/components/custom-breadcrumb/custom-breadcrumb";
import { CustomTable } from "../../../shared/components/custom-table/custom-table";
import { SERVICES } from "../../../core/services/services";
import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";
import { CustomModal } from "../../../shared/components/custom-modal/custom-modal";
import { DetailsBreakDown } from "../../../shared/components/details-break-down/details-break-down";
import { CustomConfirmDialog } from "../../../shared/components/custom-confirm-dialog/custom-confirm-dialog";
import { Toast } from "primereact/toast";
import { CreateSuperAgentUser } from "./create-super-agent-user";
import { HELPER } from "../../../shared/helper/helper";
import { CustomToast } from "../../../shared/components/alert/custom-toast";
import { ResetPassword } from "./reset-password";
import { ChangeUserStatus } from "./change-user-status";
import { SuperAgentUsersFilter } from "./super-agent-users-filter";
import ErrorBoundary from "../../../shared/components/error-boundary/error-boundary";
import { Optional } from "../../../shared/components/optional/optional";

export function SuperAgentUsers() {
  const toast = useRef(null);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [error, setError] = useState("");
  const [modalLoading, setModalLoading] = useState(false);
  const [confirmText] = useState("");
  const [itemIdForDelete] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [range] = useState(5);
  const [breakDownTitle, setBreakDownTitle] = useState("");
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [detailsError, setDetailsError] = useState(null);
  const [detailsId, setDetailsId] = useState(null);
  const [detailsMobile, setDetailsMobile] = useState(false);

  const [emptyText, setEmptyText] = useState("");
  const [currentModalIndex, setCurrentModalIndex] = useState(0);
  const [pageNo, setPageNo] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const [searchParams, setSearchParams] = useState(null);

  const tableHeaders = [
    { label: "Firstname", value: "firstname" },
    { label: "Lastname", value: "lastname" },
    { label: "Payment Facilitator", value: "paymentFacilitatorName" },
    { label: "Status", value: "active" },
    { label: "Date", value: "createdAt" },
    { label: "Actions", value: "actions" },
  ];

  const [details, setDetails] = useState([]);

  const [merchantUsers, setMerchantUsers] = useState([]);
  const [isPasswordReset] = useState(false);

  function deleteChargeType(e) {
    setModalLoading(true);
  }

  function reloadDetails() {
    viewMerchantUser(detailsId, detailsMobile);
  }

  const viewMerchantUser = useCallback((e, isMobile) => {
    setDetailsError(null);
    setDetailsId(e);
    setDetailsMobile(isMobile);
    setDetailsLoading(true);
    openModal(2, isMobile);
    let arr = [];
    const param = {
      username: e.username,
    };
    SERVICES.VIEW_MERCHANT_USER(param)
      .then((data) => {
        const result = data.result;
        setDetails([]);
        arr.push({ label: "First name", value: result?.firstname });
        arr.push({ label: "Last name", value: result?.lastname });
        arr.push({ label: "Username", value: result?.username });
        arr.push({ label: "Email", value: result?.email });
        arr.push({
          label: "Status",
          value: result?.active ? "Active" : "Inactive",
          itemCase: "active",
        });
        arr.push({
          label: "Created Date",
          value: result?.createdAt,
          itemCase: "transactionTime",
        });
        arr.push({
          label: "Payment facilitator",
          value: result?.paymentFacilitatorName,
        });
        arr.push({
          label: "Payment Facilitator Id",
          value: result?.paymentFacilitatorId,
        });
        setDetails(arr);
        setBreakDownTitle("Payment Facilitator User");
        setDetailsLoading(false);
      })
      .catch((error) => {
        setDetailsError(HELPER.PROCESS_ERROR(error));
        setDetailsLoading(false);
      });
  }, []);

  const openAction = useCallback(
    (e, action, isMobile) => {
      // eslint-disable-next-line default-case
      switch (action) {
        case "VIEW": {
          viewMerchantUser(e, isMobile);
          break;
        }
      }
    },
    [viewMerchantUser]
  );

  function goToPage(pageNo) {
    setPageNo(pageNo);
  }

  const getMerchantUsers = useCallback(() => {
    setCurrentIndex(0);
    setLoading(true);
    setMerchantUsers([]);
    const params = HELPER.TO_URL_STRING({
      page: pageNo,
      size: 10,
    });
    SERVICES.GET_MERCHANT_USER(params)
      .then((data) => {
        const result = data.result.content;
        if (!result.length) {
          setEmptyText("No payment facilitator user found ...");
        } else {
          let arr = [];
          setTotalItems(data.result.totalElements);
          setTotalPages(data.result.totalPages);
          result.forEach((e) => {
            arr.push({
              ...e,
              merchant: e?.merchantName,
              merchantId: e?.merchantId,
              active: e?.active ? "Active" : "Inactive",
              actions: "VIEW",
              detailsFunction: openAction,
            });
          });
          setMerchantUsers(arr);
        }
        setError(null);
        setCurrentIndex(1);
        setLoading(false);
      })
      .catch((error) => {
        setError(HELPER.PROCESS_ERROR(error));
        setCurrentIndex(1);
        setLoading(false);
      });
  }, [pageNo, openAction]);

  const searchMerchantUsers = useCallback(
    (query) => {
      setCurrentIndex(0);
      setVisible(false);
      setLoading(true);
      setIsSearch(true);
      setMerchantUsers([]);
      const params = HELPER.TO_URL_STRING({
        page: pageNo,
        size: 10,
      });
      SERVICES.FILTER_MERCHANT_USERS(params, query)
        .then((data) => {
          const result = data.result.content;
          if (!result.length) {
            setEmptyText("No payment facilitator user found ...");
          } else {
            let arr = [];
            setTotalItems(data.result.totalElements);
            setTotalPages(data.result.totalPages);
            result.forEach((e) => {
              arr.push({
                ...e,
                merchant: e?.merchantName,
                merchantId: e?.merchantId,
                active: e?.active ? "Active" : "Inactive",
                actions: "VIEW",
                detailsFunction: openAction,
              });
            });
            setMerchantUsers(arr);
          }
          setError(null);
          setCurrentIndex(1);
          setLoading(false);
        })
        .catch((error) => {
          setError(HELPER.PROCESS_ERROR(error));
          setCurrentIndex(1);
          setLoading(false);
        });
    },
    [pageNo, openAction]
  );

  useEffect(() => {
    if (searchParams) {
      searchMerchantUsers(searchParams);
    } else {
      getMerchantUsers();
    }
  }, [searchMerchantUsers, getMerchantUsers, searchParams]);

  function onHide() {}

  function openModal(index, isMobile) {
    setCurrentModalIndex(index);
    if (isMobile) {
      setCurrentIndex(2);
    } else {
      setVisible(true);
    }
  }

  function showResetPasswordModal() {
    setCurrentModalIndex(4);
  }

  function showChangeStatusModal() {
    setCurrentModalIndex(5);
  }

  function reload() {
    setPageNo(0);
    setSearchParams(null);
    setLoading(true);
    // setSearch(false);
    setIsSearch(false);
    setCurrentIndex(0);
    getMerchantUsers();
  }

  function closeModal(isReload) {
    if (visible) {
      setVisible(false);
    }
    if (currentIndex === 2) {
      setCurrentIndex(1);
    }

    if (isReload === true) {
      reload();
    }
  }

  function saveSearchParams(params) {
    setPageNo(0);
    setSearchParams(params);
  }

  const mobileModal = () => {
    // eslint-disable-next-line default-case
    switch (currentModalIndex) {
      case 0:
        return <CreateSuperAgentUser closeModal={closeModal} />;
      case 1:
        return (
          <SuperAgentUsersFilter
            searchFunction={saveSearchParams}
            isSearch={true}
            closeModal={closeModal}
          />
        );
      case 2:
        return (
          <DetailsBreakDown
            reload={reloadDetails}
            error={detailsError}
            loading={detailsLoading}
            title={breakDownTitle}
            breakDown={details}
            closeModal={closeModal}
            isResetPassword={true}
            resetPassword={showResetPasswordModal}
            isChangeStatus={true}
            changeStatus={showChangeStatusModal}
            userStatus={detailsId.active}
          />
        );
      case 3:
        return (
          <CustomConfirmDialog
            itemId={itemIdForDelete}
            confirmText={confirmText}
            loading={modalLoading}
            loadingText="Deleting fee type..."
            fn={deleteChargeType}
            closeModal={closeModal}
          />
        );
      case 4:
        return (
          <ResetPassword userDetails={detailsId} closeModal={closeModal} />
        );
      case 5:
        return (
          <ChangeUserStatus userDetails={detailsId} closeModal={closeModal} />
        );
    }
  };

  const merchantUsersView = () => {
    // eslint-disable-next-line default-case
    switch (currentIndex) {
      case 0:
        return (
          <div className="loading-container">
            <CustomLoader loadingText="Loading payment facilitator users..." />
          </div>
        );
      case 1:
        return (
          <CustomTable
            isReload={true}
            totalPages={totalPages}
            totalItems={totalItems}
            currentPage={pageNo + 1}
            range={range}
            emptyText={emptyText}
            search={isSearch}
            reload={reload}
            error={error}
            items={merchantUsers}
            headers={tableHeaders}
            nextPage={() => setPageNo(pageNo + 1)}
            prevPage={() => setPageNo(pageNo - 1)}
            goToFirstPage={() => setPageNo(0)}
            goToLastPage={() => setPageNo(totalPages - 1)}
            goToPage={goToPage}
          />
        );
      case 2:
        return (
          <div className="mobile-modal-container">
            <div className="custom-card">
              <div className="mobile-card-position">{mobileModal()}</div>
            </div>
          </div>
        );
    }
  };

  const modalContent = () => {
    // eslint-disable-next-line default-case
    switch (currentModalIndex) {
      case 0:
        return <CreateSuperAgentUser closeModal={closeModal} />;
      case 1:
        return (
          <SuperAgentUsersFilter
            searchFunction={saveSearchParams}
            isSearch={true}
            closeModal={closeModal}
          />
        );
      case 2:
        return (
          <DetailsBreakDown
            reload={reloadDetails}
            error={detailsError}
            loading={detailsLoading}
            title={breakDownTitle}
            breakDown={details}
            closeModal={closeModal}
            isResetPassword={true}
            resetPassword={showResetPasswordModal}
            isChangeStatus={true}
            changeStatus={showChangeStatusModal}
            userStatus={detailsId.active}
          />
        );
      case 3:
        return (
          <CustomConfirmDialog
            itemId={itemIdForDelete}
            confirmText={confirmText}
            loading={modalLoading}
            loadingText="Deleting fee type..."
            fn={deleteChargeType}
            closeModal={closeModal}
          />
        );
      case 4:
        return (
          <ResetPassword userDetails={detailsId} closeModal={closeModal} />
        );
      case 5:
        return (
          <ChangeUserStatus userDetails={detailsId} closeModal={closeModal} />
        );
    }
  };

  return (
    <ErrorBoundary>
      <div>
        <Toast ref={toast} />
        <div>
          <CustomModal
            closeModal={closeModal}
            onHide={onHide}
            visible={visible}
            modalContent={modalContent}
          />
        </div>
        <div style={{ display: isPasswordReset ? "block" : "none" }}>
          <CustomToast
            title="Success"
            description="Password successfully reset!"
            type="success"
          />
        </div>
        <div className="page-title p-text-left">Payment Facilitator Users</div>
        <div className="p-mt-2">
          <CustomBreadcrumb page={"Manage payment facilitator users"} />
        </div>
        <div className="floating-buttons desktop-scree">
          <div className="p-grid">
            <div className="p-col-7"></div>
            <div className="p-col-5">
              <div className="p-grid">
                <div className="p-col-6 p-d-flex p-jc-end p-ai-center">
                  <button
                    disabled={loading || merchantUsers?.length === 0}
                    onClick={() => openModal(1, false)}
                    className="filter-button"
                  >
                    <i className="pi pi-filter" />
                    <span className="hide-btn-text"> Filter</span>
                  </button>
                </div>
                <div className="p-col-6">
                  <Optional
                    show={HELPER.HAS_AUTHORITY(
                      "bo_dd_create_facilitator_users"
                    )}
                  >
                    <button
                      disabled={loading}
                      onClick={() => openModal(0, false)}
                      className="primary-button hide-btn-text"
                    >
                      <i className="pi pi-plus" />
                      <span className="hide-btn-text"> New user </span>
                    </button>
                  </Optional>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>{merchantUsersView()}</div>
      </div>
    </ErrorBoundary>
  );
}
